<div class="card-information-links">

  <div *ngFor="let link of additionalLinks; let i = index" class="link-para">
    <a *ngIf="link.key != 'Additional Information'" [attr.href]="link?.value" target="_blank" rel="noopener" [attr.data-id]="'termsUrl-'+pid"
      (click)="comparePricingTagging($event)" (keyup.Enter)="comparePricingTagging($event)"
      [attr.aria-label]="cardName + ' ' + getAnchorText(link, i) | adaFriendlyName: 'ariaLabel'"
      [innerHtml]="getAnchorText(link, i)" role="link" tabindex="0">
    </a>

    <a *ngIf="link.key == 'Additional Information'" role="link" tabindex="0" [attr.data-id]="'additionLink-'+pid"
      (click)="navigateToAdditionalInfoPage($event)" (keyup.Enter)="navigateToAdditionalInfoPage($event)"
      style="cursor: pointer"
      [attr.aria-label]="cardName + ' ' + getAnchorText(link, i) | adaFriendlyName: 'ariaLabel'"
      [innerHTML]="getAnchorText(link, i)">
    </a>

  </div>
</div>
